import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../app/store';
import CornerstoneConfigForm from './CornerstoneConfigForm';
import { useCornerstoneConfig } from './useCornerstoneConfig';


export const CornerstoneLmsConfiguration = () => {
  const currentUser = useSelector((state: RootState) => state.currentUser);
  const {
    config,
    isLoading,
    handleUpdateConfiguration,
    setConfig,
  }
  = useCornerstoneConfig(currentUser.organization_id);
  return (
    <div className="p-4 bg-white border rounded shadow-md">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-bold mb-4">Cornerstone Configuration</h2>
      </div>
      {isLoading ? (
        <p>Loading...</p>

      ) : (
        <CornerstoneConfigForm
          config={{
            lmsUrl: config.lmsUrl,
            proviewAdminUsername: config.proviewAdminUsername,
            proviewAdminPassword: config.proviewAdminPassword,
            proviewName:config.proviewName
          }}
          setConfig={setConfig}
          handleUpdateConfiguration={handleUpdateConfiguration}
        />
      )}
    </div>
  );
};
